import { Row, Col } from "react-bootstrap";

import ProductCard from "./ProductCard";

function FeaturedProducts({ products }) {
  return (
    <Row className="g-4">
      {products.map((product) => (
        <Col key={product.id} md={4}>
          <ProductCard product={product} />
        </Col>
      ))}
    </Row>
  );
}

export default FeaturedProducts;
